<template>
    <!-- :style="`width: 100%;height: ${height}px;background: linear-gradient(115deg, #57c9fe, #5777fe);`" -->
        <div id="user_component">
			<el-dialog title="申请修改" :visible.sync="approvalDialogFormVisible">
			  	<el-form >
			  	  	<el-form-item label="申请原因" label-width="80px">
			  	  	  	<el-input type="textarea" v-model="approval_add_reason" autocomplete="off"></el-input>
			  	  	</el-form-item>
			  	</el-form>
			  	<div slot="footer" class="dialog-footer">
			  	  	<el-button @click="approvalDialogFormVisible = false">取 消</el-button>
			  	  	<el-button type="primary" @click="approval_add()">确 定</el-button>
			  	</div>
			</el-dialog>

			<el-dialog title="学籍异动" :visible.sync="majorsDialogFormVisible">
			  	<el-form>
					<el-form-item label="学历专业" label-width="80px">
						<el-select v-model="approval_majors_grade_id" placeholder="请选择">
  							<el-option
  								v-for="item in approval_majors_arr"
  								:key="item.grade_id"
  								:label="item.major_name"
  								:value="item.grade_id">
  							</el-option>
  						</el-select>
			  	  	</el-form-item>
					<el-form-item label="附件" label-width="80px">
						<el-button type="primary" @click="selectImage1('file')">点击上传</el-button>
						<input type="file" ref="file" @change="change1($event,'file')" v-show="false"/>
						<div class="attachments_list">
							<div v-for="(item,i) in attachments" class="attachment" :key="i">
								{{ item.title }}
								<span class="delete" @click="attachment_delete(i,'file')">×</span>
							</div>
						</div>
	  	  			</el-form-item>
			  	  	<el-form-item label="申请原因" label-width="80px">
			  	  	  	<el-input type="textarea" v-model="approval_majors_reason" autocomplete="off"></el-input>
			  	  	</el-form-item>
			  	</el-form>
			  	<div slot="footer" class="dialog-footer">
			  	  	<el-button @click="majorsDialogFormVisible = false">取 消</el-button>
			  	  	<el-button type="primary" @click="add_relation_change()">确 定</el-button>
			  	</div>
			</el-dialog>
			
			<el-dialog title="文件学历类型" :visible.sync="filesEducationalFormVisible">
				<el-form>
					<el-form-item label="文件学历类型">
						<el-select v-model="files_educational_model" placeholder="请选择">
  							<el-option
  								v-for="item in education"
  								:key="item.id"
  								:label="item.value"
  								:value="item.id">
  							</el-option>
  						</el-select>
			  	  	</el-form-item>
			  	</el-form>
			  	<div slot="footer" class="dialog-footer">
			  	  	<el-button @click="filesEducationalFormVisible = false">取 消</el-button>
			  	  	<el-button type="primary" @click="files_educational()">确 定</el-button>
			  	</div>
			</el-dialog>

			<el-dialog title="前置学历及认证报告" :visible.sync="userRelationFilesFormVisible">
			  	<el-form>
					<!-- <el-form-item label="文件类型" label-width="80px">
						<el-select v-model="user_relation_files_data.type" style="width: 300px;" placeholder="请选择">
  							<el-option
  								v-for="item in $store.state.const.user_relation_files.type"
  								:key="item.id"
  								:label="item.value"
  								:value="item.id">
  							</el-option>
  						</el-select>
			  	  	</el-form-item> -->
					<el-form-item label="前置学历" label-width="80px">
						<el-button type="primary" @click="filesEducationalFormVisible = true">点击上传</el-button>
						<input type="file" ref="front_file" @change="change1($event,'front_file')" v-show="false"/>
						<div class="attachments_list">
							<div v-for="(item,i) in user_relation_files_data.data[0].attachments" class="attachment" :key="i">
								{{ item.title }}
								<span class="delete" @click="attachment_delete(i,'front_file')">×</span>
							</div>
						</div>
			  	  	</el-form-item>
					<el-form-item label="认证报告" label-width="80px">
						<el-button type="primary" @click="selectImage1('evidence_file')">点击上传</el-button>
						<input type="file" ref="evidence_file" @change="change1($event,'evidence_file')" v-show="false"/>
						<div class="attachments_list">
							<div v-for="(item,i) in user_relation_files_data.data[1].attachments" class="attachment" :key="i">
								{{ item.title }}
								<span class="delete" @click="attachment_delete(i,'evidence_file')">×</span>
							</div>
						</div>
			  	  	</el-form-item>
			  	  	<el-form-item label="备注" label-width="80px">
			  	  	  	<el-input type="textarea" v-model="user_relation_files_data.remark" autocomplete="off"></el-input>
			  	  	</el-form-item>
			  	</el-form>
			  	<div slot="footer" class="dialog-footer">
			  	  	<el-button @click="userRelationFilesFormVisible = false">取 消</el-button>
			  	  	<el-button type="primary" @click="post_user_relation_files()">确 定</el-button>
			  	</div>
			</el-dialog>

			<el-dialog title="受教育或培训经历" :visible.sync="user_relation_edus_visible" :close-on-click-modal="false">
				<div class="mb-20">
					是否新增空记录：<el-checkbox v-model="user_relation_edus_data.null_data">{{user_relation_edus_data.null_data ? '是' : '否'}}</el-checkbox>
				</div>
			  	<el-form v-show="!user_relation_edus_data.null_data" v-loading="visible_loading" label-position="top" :model="user_relation_edus_data" :rules="user_relation_edus_rules" ref="user_relation_edus_ref" class="dialog_form" :inline="true">
					<el-row :gutter="20">
						<el-col style="width: 22.83333%;">
							<el-form-item label="开始时间"  prop="start_date">
								<el-date-picker type="date" placeholder="开始日期" value-format="yyyy-MM-dd" v-model="user_relation_edus_data.start_date"></el-date-picker>
			  	  			</el-form-item>
						</el-col>
						<el-col class="line" :span="1" style="line-height: 90px;">-</el-col>
						<el-col style="width: 22.83333%;">
							<el-form-item label="结束时间"  prop="end_date">
								<el-date-picker type="date" placeholder="结束日期" value-format="yyyy-MM-dd" v-model="user_relation_edus_data.end_date"></el-date-picker>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="学校/培训机构名称" prop="edu_name">
			  	  			  	<el-input type="text" v-model="user_relation_edus_data.edu_name" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="学历" prop="education_level">
								<el-select v-model="user_relation_edus_data.education_level" placeholder="请选择" @change="user_relation_edus_education_level">
  									<el-option
  										v-for="item in education"
  										:key="item.id"
  										:label="item.value"
  										:value="item.id"
										>
  									</el-option>
  								</el-select>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="专业" prop="major">
			  	  			  	<el-input type="text" v-model="user_relation_edus_data.major" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="证明人">
			  	  			  	<el-input type="text" v-model="user_relation_edus_data.contacts" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
					</el-row>
			  	</el-form>
			  	<div slot="footer" class="dialog-footer">
			  	  	<el-button @click="user_relation_edus_visible = false">取 消</el-button>
			  	  	<el-button type="primary" @click="save_data('user_relation_edus')">确 定</el-button>
			  	</div>
			</el-dialog>

			<el-dialog title="工作经历" :visible.sync="user_relation_works_visible" :close-on-click-modal="false">
				<div class="mb-20">
					是否新增空记录：<el-checkbox v-model="user_relation_works_data.null_data">{{user_relation_works_data.null_data ? '是' : '否'}}</el-checkbox>
				</div>
			  	<el-form v-show="!user_relation_works_data.null_data" v-loading="visible_loading" label-position="top" :model="user_relation_works_data" :rules="user_relation_works_rules" ref="user_relation_works_ref" class="dialog_form" :inline="true">
					<el-row :gutter="20">
						<el-col style="width: 22.83333%;">
							<el-form-item label="开始时间"  prop="start_date">
								<el-date-picker type="date" placeholder="开始日期" value-format="yyyy-MM-dd" v-model="user_relation_works_data.start_date"></el-date-picker>
			  	  			</el-form-item>
						</el-col>
						<el-col class="line" :span="1" style="line-height: 90px;">-</el-col>
						<el-col style="width: 22.83333%;">
							<el-form-item label="结束时间"  prop="end_date">
								<el-date-picker type="date" placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" v-model="user_relation_works_data.end_date"></el-date-picker>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="工作单位" prop="company_name">
			  	  			  	<el-input type="text" v-model="user_relation_works_data.company_name" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="职位" prop="position">
			  	  			  	<el-input type="text" v-model="user_relation_works_data.position" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="证明人">
			  	  			  	<el-input type="text" v-model="user_relation_works_data.contacts" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
					</el-row>
			  	</el-form>
			  	<div slot="footer" class="dialog-footer">
			  	  	<el-button @click="user_relation_works_visible = false">取 消</el-button>
			  	  	<el-button type="primary" @click="save_data('user_relation_works')">确 定</el-button>
			  	</div>
			</el-dialog>

			<el-dialog title="家庭成员" :visible.sync="user_relation_family_members_visible" :close-on-click-modal="false">
				<div class="mb-20">
					是否新增空记录：<el-checkbox v-model="user_relation_family_members_data.null_data">{{user_relation_family_members_data.null_data ? '是' : '否'}}</el-checkbox>
				</div>
			  	<el-form v-show="!user_relation_family_members_data.null_data" v-loading="visible_loading" label-position="top" :model="user_relation_family_members_data" :rules="user_relation_family_members_rules" ref="user_relation_family_members_ref" class="dialog_form" :inline="true">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="姓名" prop="name">
			  	  			  	<el-input type="text" v-model="user_relation_family_members_data.name" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="关系" prop="relation">
			  	  			  	<el-input type="text" v-model="user_relation_family_members_data.relation" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="工作单位" prop="company_name">
			  	  			  	<el-input type="text" v-model="user_relation_family_members_data.company_name" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="职位">
			  	  			  	<el-input type="text" v-model="user_relation_family_members_data.position" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系方式" prop="contact">
			  	  			  	<el-input type="text" v-model="user_relation_family_members_data.contact" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
						<!-- <el-col :span="12">
							<el-form-item label="年龄">
			  	  			  	<el-input type="text" v-model="user_relation_family_members_data.age" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col> -->
						<el-col :span="12">
							<el-form-item label="政治面貌">
			  	  			  	<el-input type="text" v-model="user_relation_family_members_data.polit_face" autocomplete="off"></el-input>
			  	  			</el-form-item>
						</el-col>
					</el-row>
			  	</el-form>
			  	<div slot="footer" class="dialog-footer">
			  	  	<el-button @click="user_relation_family_members_visible = false">取 消</el-button>
			  	  	<el-button type="primary" @click="save_data('user_relation_family_members')">确 定</el-button>
			  	</div>
			</el-dialog>

			

            <el-dialog
	        	title="验证不通过"
	        	:visible.sync="dialogVisible"
	        	width="710px">
	        	<div>
	        		<span>不通过原因:</span>
	        		<span style="color: red;">上传的证件照片证件号与学籍证件号不匹配，请上传正确的证件照片或联系教务修改学籍信息</span>
	        	</div>
	        	<div>
	        		<span>上传的证件信息如下：</span>
	        	</div>
	        	<div>
	        		<span>姓名:</span>
	        		<span>{{cradInfo.words_result['姓名'].words}}</span>
	        	</div>
	        	<div>
	        		<span>性别:</span>
	        		<span>{{cradInfo.words_result['性别'].words}}</span>
	        	</div>
	        	<div>
	        		<span>民族:</span>
	        		<span>{{cradInfo.words_result['民族'].words}}</span>
	        	</div>
	        	<div>
	        		<span>身份证号:</span>
	        		<span>{{cradInfo.words_result['公民身份号码'].words}}</span>
	        	</div>
	        	<span slot="footer" class="dialog-footer">
	        	  <el-button @click="dialogVisible = false" type="primary">确定信息</el-button>
	        	</span>
	        </el-dialog>

			<el-dialog title="电子学生卡" v-if="xuejiInfoDisplay" @opened="student_id_card_opened" :visible.sync="student_id_card_visible" width="520px" :close-on-click-modal="false">
				<div class="student_id_card_con">
					<img :src='global.oss_website+"/pc/images/student_id_card_bg.png"' class="student_id_card_bg">
					<div class="information">
						<div>姓名：{{ ruleForm.profile.nick_name }}</div>
						<div>学号：{{ ruleForm.student_sn }}</div>
					</div>
					<img :src='global.oss_website+"/pc/images/zhanjiang_logo.png"' class="zhanjiang_logo">
				</div>
				<div class="student_id_card_con back">
					<img :src='global.oss_website+"/pc/images/student_id_card_bg.png"' class="student_id_card_bg">
					<div class="information">
						<div>年级：{{ ruleForm.grade.grade_name }}</div>
						<div>层次：{{ ruleForm.cengci }}</div>
						<div>专业：{{ ruleForm.major.major_name }}</div>
						<div>院校/学院：{{ ruleForm.school.school_name }}</div>
					</div>
					<div class="information_qr_code">
						<div id="qr_code"></div>
						<!-- <qrcode-vue :value="qrcode_value" size="86"></qrcode-vue> -->
					</div>
				</div>
			  	<!-- <div slot="footer" class="dialog-footer">
			  	  	<el-button @click="user_relation_family_members_visible = false">取 消</el-button>
			  	  	<el-button type="primary" @click="save_data('user_relation_family_members')">确 定</el-button>
			  	</div> -->
			</el-dialog>

			<div class="user_detail_box">
				<div id="xinxi" class="xinxi">
					

            	    <div class="uinfo">
						<div class="alert" v-if="approval_status_text[ruleForm.approval_status]" :class="approval_status_text[ruleForm.approval_status]">
							{{ruleForm.approval_remark}}
						</div>
	        	    	<div class="picture" v-if="ruleForm.profile.graduate_pic">
	        	    		<!-- <div class="photo" v-if="ruleForm.profile.entrance_pic">
	        	    			<div class="upload_photo">
	        	    				<img :src="global.oss_link+ruleForm.profile.entrance_pic">
	        	    			</div>
							
	        	    			<div class="photo_title">入学照片</div>
	        	    		</div> -->
	        	    		<div class="photo">
	        	    			<div class="upload_photo">
	        	    				<img :src="global.oss_link+ruleForm.profile.graduate_pic">
	        	    			</div>
	        	    			<div class="photo_title">毕业照片</div>
	        	    		</div>
	        	    	</div>
            	        <div class="titBox">
            	            <p class="tit">基本信息</p>
							<div class="tip fl" v-if="uinfoBtn">本页面所有栏目内容均需要填写，请务必填写完成。</div>
							<el-button class="edit_btn" type="primary" v-if="foundation_data_disabled && disable_edit" @click="foundation_data_disabled=false" size="mini">编辑</el-button>
							<el-button class="edit_btn" type="danger" v-if="!foundation_data_disabled && disable_edit" @click="cancel_save" size="mini">取消</el-button>
							<el-button class="edit_btn" type="primary" @click="foundation_save()" v-if="!foundation_data_disabled && disable_edit" size="mini">保存</el-button>
							<el-button class="edit_btn" type="primary" v-if="admission_btn_visible" @click="admission_visible" size="mini">录取通知书下载</el-button>
            	        </div>
	        	    	<el-form :model="ruleForm" ref="ruleForm" class="uinfoForm" style="padding-bottom: 0;">
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">学生姓名</label>
	        	    			<el-input v-model="ruleForm.profile.nick_name" disabled type="text" name="uname" id="uname" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
							<el-form-item class="lineInput">
            	                <label class="labelTit">曾用名</label>
	        	    			<el-input v-model="ruleForm.profile.previous_name" :disabled="foundation_data_disabled" type="text" name="previous_name" id="previous_name" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">性别</label>
	        	    			<el-input v-model="ruleForm.sex" type="text" disabled name="sex" id="sex" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">出生日期</label>
	        	    			<el-input v-model="ruleForm.profile.birthday" disabled type="text" name="birthDate" id="birthDate" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput" prop="mobile">
            	                <label class="labelTit">手机号码</label>
	        	    			<el-input v-model="ruleForm.profile.mobile" :disabled="foundation_data_disabled" type="text" name="phone" id="phone" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<!-- <el-form-item class="lineInput">
            	                <label class="labelTit">最高学历</label>
	        	    			<el-input v-model="ruleForm.xueli" type="text" name="xueli" id="xueli" placeholder="暂无填写"></el-input>
	        	    		</el-form-item> -->
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">证件类型</label>
	        	    			<el-input v-model="ruleForm.idcardType" disabled type="text" name="idcardType" id="idcardType" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">证件号码</label>
	        	    			<el-input v-model="ruleForm.profile.idcard" disabled type="text" name="idcard" id="idcard" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
							<el-form-item class="lineInput">
            	                <label class="labelTit">邮箱</label>
	        	    			<el-input v-model="ruleForm.profile.email" :disabled="foundation_data_disabled" type="text" name="email" id="email" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
							<el-form-item class="lineInput"  prop="marital_status">
            	                <label class="labelTit">婚姻状态</label>
								<el-select v-model="ruleForm.profile.marital_status" :disabled="foundation_data_disabled" placeholder="请选择">
  									<el-option
  										v-for="item in marital_status"
  										:key="item.if"
  										:label="item.value"
  										:value="item.id">
  									</el-option>
  								</el-select>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput"  prop="polit_face">
	        	    			<label class="labelTit">政治面貌</label>
	        	    			<el-input v-model="ruleForm.profile.polit_face" :disabled="foundation_data_disabled" type="text" name="polit_face" id="polit_face" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput"  prop="nation">
            	                <label class="labelTit">民族</label>
	        	    			<el-input v-model="ruleForm.profile.nation" :disabled="foundation_data_disabled" type="text" name="nation" id="nation" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput"  prop="household_register">
            	                <label class="labelTit">户籍</label>
	        	    			<el-input v-model="ruleForm.profile.household_register" :disabled="foundation_data_disabled" type="text" name="household_register" id="household_register" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput"  prop="is_overseas_chinese">
            	                <label class="labelTit">是否华侨</label>
								<el-select v-model="ruleForm.profile.is_overseas_chinese" :disabled="foundation_data_disabled" placeholder="请选择">
  									<el-option
  										v-for="item in correct_deny_arr"
  										:key="item.value"
  										:label="item.label"
  										:value="item.value">
  									</el-option>
  								</el-select>
	        	    			<!-- <el-input v-model="ruleForm.is_overseas_chinese_text" disabled type="text" name="minzu" id="minzu" placeholder="暂无填写"></el-input> -->
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput"  prop="is_gangaotai">
            	                <label class="labelTit">是否港澳台</label>
								<el-select v-model="ruleForm.profile.is_gangaotai" :disabled="foundation_data_disabled" placeholder="请选择">
  									<el-option
  										v-for="item in correct_deny_arr"
  										:key="item.value"
  										:label="item.label"
  										:value="item.value">
  									</el-option>
  								</el-select>
	        	    			<!-- <el-input v-model="ruleForm.is_gangaotai_text" :disabled="foundation_data_disabled" type="text" name="minzu" id="minzu" placeholder="暂无填写"></el-input> -->
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput"  prop="is_disability">
            	                <label class="labelTit">是否残疾</label>
								<el-select v-model="ruleForm.profile.is_disability" :disabled="foundation_data_disabled" placeholder="请选择">
  									<el-option
  										v-for="item in correct_deny_arr"
  										:key="item.value"
  										:label="item.label"
  										:value="item.value">
  									</el-option>
  								</el-select>
	        	    			<!-- <el-input v-model="ruleForm.is_disability_text" :disabled="foundation_data_disabled" type="text" name="minzu" id="minzu" placeholder="暂无填写"></el-input> -->
	        	    		</el-form-item>
							<el-form-item class="lineInput"  prop="postcode">
            	                <label class="labelTit">邮编</label>
	        	    			<el-input v-model="ruleForm.profile.postcode" :disabled="foundation_data_disabled" type="text" name="postcode" id="postcode" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
							<el-form-item class="lineInput lineTextarea"  prop="address">
            	                <label class="labelTit">通讯地址</label>
	        	    			<el-input v-model="ruleForm.profile.address" :disabled="foundation_data_disabled" type="text" name="address" id="address" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
							<el-form-item class="lineInput lineTextarea siblings">
	        	    			<label class="labelTit">籍贯</label>
								<div class="siblings_div">
									<el-select :filterable="true" v-model="ruleForm.profile[siblings_item.key]" :disabled="foundation_data_disabled" v-for="(siblings_item,i) in siblings_arr" :key="i" @change="get_children(siblings_item.nex_key,ruleForm.profile[siblings_item.key])">
  										<el-option
  											v-for="item in siblings_item.arr"
  											:key="item.id"
  											:label="item.name"
  											:value="item.id">
  										</el-option>
  									</el-select>
								</div>
	        	    			
	        	    		</el-form-item>
							<el-form-item class="lineInput lineTextarea">
            	                <label class="labelTit" style="width: 400px;">加入中国共产党/中国共青团时间与职务</label>
	        	    			<el-input v-model="ruleForm.profile.join_party_league" :rows="1" :resize="foundation_data_disabled?'':'both'" :disabled="foundation_data_disabled" type="textarea" name="join_party_league" id="join_party_league" :placeholder="foundation_data_disabled?'暂无填写':'请输入加入共产党/共青团的时间与职务'"></el-input>
	        	    		</el-form-item>
							<el-form-item class="lineInput lineTextarea">
            	                <label class="labelTit">奖励与处罚</label>
	        	    			<el-input v-model="ruleForm.profile.award_or_punishment" :rows="3" :resize="foundation_data_disabled?'':'both'" :disabled="foundation_data_disabled" type="textarea" name="award_or_punishment" id="award_or_punishment" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
							<el-form-item class="lineInput lineTextarea">
            	                <label class="labelTit">自我鉴定</label>
	        	    			<el-input v-model="ruleForm.profile.self_identification_file" show-word-limit :maxlength="500" :rows="6" :resize="foundation_data_disabled?'':'both'" :disabled="foundation_data_disabled" type="textarea" name="self_identification_file" id="self_identification_file" :placeholder="foundation_data_disabled?'暂无填写':'请填写自我鉴定（最多500字）'"></el-input>
	        	    		</el-form-item>
            	        </el-form>
                        <ul class="document_list" :style="uinfoBtn?'padding: 0 30px;':'padding: 0 60px;'">
							<li id="user_photo">
                                <p class="require"><b>蓝底证件照</b>要求：蓝底证件照，jpg格式，图片＜5Mb</p>
                                <div class="file_preview_box">
                                    <div class="file_preview">
                                        <img :src="ruleForm.profile.entrance_pic?global.oss_link + ruleForm.profile.entrance_pic:st_document" alt="证件照" class="user_photo_img" />
                                    </div>
                                    <div class="document_data_ctrl">
		                				<el-upload
                                            class="upload-demo"
                                            action="#"
                                            :limit="1"
                                            :auto-upload="false"
		                				    :on-exceed="handle_exceed_entrance_pic"
                                            :show-file-list="false"
                                            :file-list="file_list_zheng">
                                            <el-button v-if="!foundation_data_disabled" size="small" type="primary">上传入学照片</el-button>
                                        </el-upload>
                                    </div>
                                </div>
                            </li>
                            <li id="idcard">
                                <p class="require"><b>身份证</b>要求：包含正面、反面，截掉周围多余部分、正向横向上传，jpg格式，图片＜5Mb</p>
                                <div class="file_preview_box">
                                    <div class="file_preview">
                                        <img :src="ruleForm.profile.id_frontend_thumb?global.oss_link + ruleForm.profile.id_frontend_thumb:yangbenzheng" alt="身份证正面" class="idcard_img1" />
                                    </div>
                                    <div class="document_data_ctrl">
                                        <el-upload
                                            class="upload-demo"
                                            action="#"
                                            :limit="1"
                                            :auto-upload="false"
		                				    :on-exceed="handle_exceed"
                                            :show-file-list="false"
                                            :file-list="file_list_zheng">
                                            <el-button v-if="!foundation_data_disabled" size="small" type="primary">上传身份证正面</el-button>
                                        </el-upload>
                                    </div>
                                </div>
                                <div class="file_preview_box">
                                    <div class="file_preview">
                                        <img :src="ruleForm.profile.id_backend_thumb?global.oss_link + ruleForm.profile.id_backend_thumb:yangbenfan" alt="身份证反面" class="idcard_img2" />
                                    </div>
                                    <div class="document_data_ctrl">
		                				<el-upload
                                            class="upload-demo"
                                            action="#"
                                            :limit="1"
                                            :auto-upload="false"
		                				    :on-exceed="handle_exceed_fan"
                                            :show-file-list="false"
                                            :file-list="file_list_zheng">
                                            <el-button v-if="!foundation_data_disabled" size="small" type="primary">上传身份证反面</el-button>
                                        </el-upload>
                                    </div>
                                </div>
                            </li>
                            
                        </ul>
            	    </div>

					<div class="qianzhixueliInfo">
						<div class="titBox">
    				        <p class="tit">前置学历及认证报告<span class="tit_tips2">（上传报名时的前置学历及对应电子注册备案表）</span> </p>
							<el-button class="edit_btn" type="primary" v-if="disable_edit" @click="user_relation_files_open()" size="mini">上传文件</el-button>
    				    </div>
						<div class="relation_table">
							<el-table :data="user_relation_files_list" stripe header-cell-class-name="paper_tab_head" v-loading="files_table_loading" border>
								<el-table-column align="center" class-name="title" label="标题">
        					        <template slot-scope="scope">
        					            {{scope.row.attachment.title}}
									</template>
								</el-table-column>
								<el-table-column prop="upload_at" align="center" class-name="title" label="上传时间" width="200"></el-table-column>
								<!-- <el-table-column align="center" class-name="title" label="审核状态" width="180">
									<template slot-scope="scope">
        					            {{ get_const_txt($store.state.const.user_relation_files.status,scope.row.status) }}
									</template>
								</el-table-column>
								<el-table-column prop="audit_at" align="center" class-name="title" label="审核时间" width="180"></el-table-column>
								<el-table-column prop="audit_remark" align="center" class-name="title" label="审批反馈"></el-table-column> -->
        					    <el-table-column prop="termTxt" align="center" label="操作" width="160">
        					        <template slot-scope="scope">
        					            <el-button type="text" size="small" @click="view_file(scope.row.attachment.url)">查看</el-button>
										<!-- <el-button type="text" size="small" v-if="scope.row.status==5" disabled>删除</el-button> -->
										<el-button type="text" size="small" v-if="disable_edit" @click="delete_file(scope.row.id,scope.row.attachment.url)">删除</el-button>
        					        </template>
        					    </el-table-column>
							</el-table>
						</div>
					</div>

					<div class="jiaoyujingliInfo">
						<div class="titBox">
    				        <p class="tit">受教育或培训经历<span class="tit_tips2">从初中填起，包括初中、高中（或中专）和大专（前置学历最高如果是本科也要填，大专信息按照上传的电子注册备案表填写）</span> </p>
							<el-button class="edit_btn" type="primary" v-if="disable_edit" @click="edit_data('user_relation_edus')" size="mini">新增</el-button>
    				    </div>
						<div class="relation_table">
							<el-table :data="user_relation_edus_list" stripe header-cell-class-name="paper_tab_head" v-loading="user_relation_edus_loading" border>
								<el-table-column align="center" class-name="title" label="教育/培训时间" width="200">
        					        <template slot-scope="scope">
        					            {{scope.row.start_date ? scope.row.start_date+' ~ '+scope.row.end_date : '无'}}
									</template>
								</el-table-column>
								<el-table-column prop="edu_name" align="center" class-name="title" label="学校/培训机构名称">
        					        <template slot-scope="scope">
        					            {{scope.row.edu_name ? scope.row.edu_name : '无'}}
									</template>
								</el-table-column>
								<el-table-column align="center" class-name="title" label="学历" width="120">
									<template slot-scope="scope">
        					            {{ get_const_txt(education,scope.row.education_level) }}
									</template>
								</el-table-column>
								<el-table-column prop="major" align="center" class-name="title" label="专业" width="150">
        					        <template slot-scope="scope">
        					            {{scope.row.major ? scope.row.major : '无'}}
									</template>
								</el-table-column>
								<el-table-column prop="contacts" align="center" class-name="title" label="证明人" width="150">
        					        <template slot-scope="scope">
        					            {{scope.row.contacts ? scope.row.contacts : '无'}}
									</template>
								</el-table-column>
        					    <el-table-column prop="termTxt" align="center" label="操作" width="120">
        					        <template slot-scope="scope">
        					            <el-button type="text" size="small" v-if="disable_edit" @click="edit_data('user_relation_edus',scope.row)">编辑</el-button>
										<el-button type="text" size="small" v-if="disable_edit" @click="delete_data('user_relation_edus',scope.row)">删除</el-button>
        					        </template>
        					    </el-table-column>
							</el-table>
						</div>
					</div>

					<div class="gongzuojingliInfo">
						<div class="titBox">
    				        <p class="tit">工作经历</p>
							<el-button class="edit_btn" v-if="disable_edit" type="primary" @click="edit_data('user_relation_works')" size="mini">新增</el-button>
    				    </div>
						<div class="relation_table">
							<el-table :data="user_relation_works_list" stripe header-cell-class-name="paper_tab_head" v-loading="user_relation_works_loading" border>
								<el-table-column align="center" class-name="title" label="工作时间" width="200">
        					        <template slot-scope="scope">
        					            {{scope.row.start_date ? scope.row.start_date+' ~ '+(scope.row.end_date?scope.row.end_date:'至今') : '无'}}
									</template>
								</el-table-column>
								<el-table-column prop="company_name" align="center" class-name="title" label="工作单位">
        					        <template slot-scope="scope">
        					            {{scope.row.company_name ? scope.row.company_name : '无'}}
									</template>
								</el-table-column>
								<el-table-column prop="position" align="center" class-name="title" label="职位" width="150">
        					        <template slot-scope="scope">
        					            {{scope.row.position ? scope.row.position : '无'}}
									</template>
								</el-table-column>
								<el-table-column prop="contacts" align="center" class-name="title" label="证明人" width="120">
        					        <template slot-scope="scope">
        					            {{scope.row.contacts ? scope.row.contacts : '无'}}
									</template>
								</el-table-column>
        					    <el-table-column prop="termTxt" align="center" label="操作" width="120">
        					        <template slot-scope="scope">
        					            <el-button type="text" size="small" v-if="disable_edit" @click="edit_data('user_relation_works',scope.row)">编辑</el-button>
										<el-button type="text" size="small" v-if="disable_edit" @click="delete_data('user_relation_works',scope.row)">删除</el-button>
        					        </template>
        					    </el-table-column>
							</el-table>
						</div>
					</div>

					<div class="jiatingchengyuanInfo">
						<div class="titBox">
    				        <p class="tit">家庭成员</p>
							<el-button class="edit_btn" type="primary" v-if="disable_edit" @click="edit_data('user_relation_family_members')" size="mini">新增</el-button>
    				    </div>
						<div class="relation_table">
							<el-table :data="user_relation_family_members_list" stripe header-cell-class-name="paper_tab_head" v-loading="user_relation_family_members_loading" border>
								<el-table-column prop="name" align="center" class-name="title" label="姓名" width="120">
        					        <template slot-scope="scope">
        					            {{scope.row.name ? scope.row.name : '无'}}
									</template>
								</el-table-column>
								<el-table-column prop="relation" align="center" class-name="title" label="关系" width="120">
        					        <template slot-scope="scope">
        					            {{scope.row.relation ? scope.row.relation : '无'}}
									</template>
								</el-table-column>
								<el-table-column prop="company_name" align="center" class-name="title" label="工作单位">
        					        <template slot-scope="scope">
        					            {{scope.row.company_name ? scope.row.company_name : '无'}}
									</template>
								</el-table-column>
								<el-table-column prop="position" align="center" class-name="title" label="职位" width="150">
        					        <template slot-scope="scope">
        					            {{scope.row.position ? scope.row.position : '无'}}
									</template>
								</el-table-column>
								<el-table-column prop="contact" align="center" class-name="title" label="联系方式" width="180">
        					        <template slot-scope="scope">
        					            {{scope.row.contact ? scope.row.contact : '无'}}
									</template>
								</el-table-column>
								<!-- <el-table-column align="center" class-name="title" label="年龄" width="100">
									<template slot-scope="scope">
										{{ scope.row.age + '岁' }}
        					        </template>
								</el-table-column> -->
								<el-table-column prop="polit_face" align="center" class-name="title" label="政治面貌" width="100">
        					        <template slot-scope="scope">
        					            {{scope.row.polit_face ? scope.row.polit_face : '无'}}
									</template>
								</el-table-column>
        					    <el-table-column prop="termTxt" align="center" label="操作" width="120">
        					        <template slot-scope="scope">
        					            <el-button type="text" size="small" v-if="disable_edit" @click="edit_data('user_relation_family_members',scope.row)">编辑</el-button>
										<el-button type="text" size="small" v-if="disable_edit" @click="delete_data('user_relation_family_members',scope.row)">删除</el-button>
        					        </template>
        					    </el-table-column>
							</el-table>
						</div>
					</div>


            	    <div class="xuejiInfo" v-if="xuejiInfoDisplay && approval_majors_arr.length">
            	        <div class="titBox">
            	            <p class="tit">学籍资料</p>
							<el-button class="edit_btn" type="primary" @click="student_id_card()" size="mini"
							 v-if="school_extra && school_extra.system.student_idcard.bg">电子学生证</el-button>
							<!-- <el-button class="edit_btn" type="primary" v-if="disable_edit" @click="apply_for_unusual_change()" size="mini">申请学籍异动</el-button> -->
	        	    		<!-- <div class="titRightBox">
	        	    			<el-button class="yidong" plain>申请学籍异动</el-button>
	        	    		</div> -->
            	        </div>
	        	    	<el-form :model="ruleForm" ref="ruleForm" class="xuejiForm" disabled>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">报考学校</label>
	        	    			<el-input v-model="ruleForm.school.school_name" type="text" name="school" id="school" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">年级</label>
	        	    			<el-input v-model="ruleForm.grade.grade_name" type="text" name="nian" id="nian" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">学历层次</label>
	        	    			<el-input v-model="ruleForm.cengci" type="text" name="cengci" id="cengci" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">报考专业</label>
	        	    			<el-input v-model="ruleForm.major.major_name" type="text" name="zhuanye" id="zhuanye" placeholder="暂无填写"></el-input>
	        	    		</el-form-item> 
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">班级</label>
	        	    			<el-input v-model="ruleForm.grade.class_name" type="text" name="banji" id="banji" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">学号</label>
	        	    			<el-input v-model="ruleForm.student_sn" type="text" name="xuehao" id="xuehao" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">学制</label>
	        	    			<el-input v-model="ruleForm.edu_system" type="text" name="xuezhi" id="xuezhi" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">学籍状态</label>
	        	    			<el-input v-model="ruleForm.xuejiSt" type="text" name="xuejiSt" id="xuejiSt" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<!-- <el-form-item class="lineInput">
	        	    			<label class="labelTit">教学点</label>
	        	    			<el-input v-model="ruleForm.org.name" type="text" name="area" id="area" placeholder="暂无填写"></el-input>
	        	    		</el-form-item>
	        	    		<el-form-item class="lineInput">
	        	    			<label class="labelTit">校区</label>
	        	    			<el-input v-model="ruleForm.market.place_name" type="text" name="area" id="area" placeholder="暂无填写"></el-input>
	        	    		</el-form-item> -->
	        	    		<!-- <el-form-item class="lineInput">
	        	    			<label class="labelTit">异动审核状态</label>
	        	    			<el-input disabled v-model="ruleForm.yidong" type="text" name="yidong" id="yidong" placeholder="暂无填写"></el-input>
	        	    		</el-form-item> -->
            	        </el-form>
            	    </div>
            	</div>
			</div>
            <download_admission ref="admission_ref"
			 :profile="ruleForm.profile"
			 :mailing_apply="mailing_apply"
			 :user_id="ruleForm.user_id"
			></download_admission>
        </div>
        
    </template>
    
<script>
// import { TableColumn } from 'element-ui'
	import QRCode from 'qrcodejs2'
	import download_admission from "./download_admission.vue";					// 录取通知书下载

	const yangbenzheng = 'https://oss.test5184.com/520.test5184.com/entryForm/images/yangbenzheng.png'
	const yangbenfan = 'https://oss.test5184.com/520.test5184.com/entryForm/images/yangbenfan.png'
	const st_document = 'https://oss.test5184.com/520.test5184.com/entryForm/images/st_document1.jpg'
	function xuejiTxt(ji){
		switch (ji){
			case 1:
				return "在读"
			case 2:
				return "毕业"
			case 3:
				return "停学"
			case 4:
				return "退学"
		}
	}
    export default {
        props: {
            uinfoBtn: {
                type: Boolean,
                default: true
            },
            xuejiInfoDisplay: {
                type: Boolean,
                default: true
            },
            getMyUserRelation: Function,
        },
        name: 'user_component'
        // ,props:["muban_bol"]
        ,components:{
            download_admission,
            // ddy
        }
        ,data () {
			var validate_datetime = (rule, value, callback) => {
				if (!value) {
        		  	callback(new Error('请选择日期'));
        		} else if (value.length<2) {
        		  	callback(new Error('请选择日期'));
        		} else {
        		  	callback();
        		}
      		};
            return {
                ruleForm: {
			    	profile:{
						user_relation_id: "",
					},
			    	grade:{
						grade_name: "",
					},
			    	major:{},
			    	market:{},
			    	mould:{},
			    	school:{},
			    	org:{},
			    	uname: '',
			    	uphone: '',
			    	area: '',
			    	email: '',
			    	school: '',
			    	grade: '',
			    	cengci: '',
			    	zhuanye: '',
			    	idcard:'',
			    	idcardInput:'',
			    	pass:'',
			    	checkPass:'',
			    	certified:false, //是否已经实名认证
			    	is_certified:2, //是否开启实名认证
					disable_edit:1,
			    },
				yangbenzheng,
				yangbenfan,
				st_document,
                image_status_text:{
			    	'normal':'识别正常',
			    	'reversed_side':'身份证正反面颠倒',
			    	'non_idcard':'上传的图片中不包含身份证',
			    	'blurred':'身份证模糊',
			    	'other_type_card':'其他类型证照',
			    	'over_exposure':'身份证关键字段反光或过曝',
			    	'over_dark':'身份证欠曝（亮度过低）',
			    	'unknown':'未知状态',
			    },
                file_list_zheng:[{name: '身份证',url:''}],
				correct_deny_arr:[{label:'是',value:1},{label:'否',value:2}],
				foundation_data_disabled:true,
				approvalDialogFormVisible:false,
				approval_add_reason:'',
				approval_majors_arr:[],
				majorsDialogFormVisible:false,
				approval_majors_reason:'',
				approval_majors_grade_id:'',
				attachments:[],
				//前置学历参数
				userRelationFilesFormVisible:false,
				user_relation_files_data:{
					data:[
						{
                		    type: 1,
                		    attachments: [],
                		},
						{
                		    type: 2,
                		    attachments: [],
                		}
					],
					// attachments:[],
					type:1,
					remark:''
				},
				user_relation_files_list:[],
				files_table_loading:false,
				visible_loading:false,//弹窗统一加载
				//受教育或培训经历相关数据 list列表、data新增编辑数据、loading列表加载、visible新增编辑弹窗、rules表单验证
				user_relation_edus_list:[],	
				user_relation_edus_data:{
					edu_name: "",
					start_date: "",
					end_date: "",
					education_level: "",
					major: "",
					contacts: "",
					datetime:"",
					null_data: false,
				},
				user_relation_edus_loading:false,
				user_relation_edus_visible:false,
				user_relation_edus_rules:{
					// datetime:[
					// 	{ required: true, validator: validate_datetime, trigger: 'blur' }
          			// ],
					start_date: [
          			  	{ required: true, message: '请选择开始时间', trigger: 'blur' }
          			],
					  end_date: [
          			  	{ required: true, message: '请选择结束时间', trigger: 'blur' }
          			],
					education_level: [
          			  	{ required: true, message: '请选择学历', trigger: 'change' }
          			],
					edu_name: [
          			  	{ required: true, message: '请填写学校/培训机构名称', trigger: 'blur' }
          			],
					major: [
          			  	{ required: true, message: '请填写专业', trigger: 'blur' }
          			],
					//major: [
          			//  	{ required: true, message: '请填写专业', trigger: 'blur' }
          			//],
					//contacts: [
          			//  	{ required: true, message: '请填写证明人', trigger: 'blur' }
          			//]
				},

				//工作经历相关数据
				user_relation_works_list:[],	
				user_relation_works_data:{
					company_name: "",
					start_date: "",
					end_date: "",
					position: "",
					contacts: "",
					datetime:"",
					null_data: false,
				},
				user_relation_works_loading:false,
				user_relation_works_visible:false,
				user_relation_works_rules:{
					// datetime:[
					// 	{ required: true, validator: validate_datetime, trigger: 'blur' }
          			// ],
					start_date: [
          			  	{ required: true, message: '请选择开始时间', trigger: 'blur' }
          			],
					// end_date: [
          			//   	{ required: true, message: '请选择结束时间', trigger: 'blur' }
          			// ],
					company_name: [
          			  	{ required: true, message: '请填写公司名称', trigger: 'blur' }
          			],
					position: [
          			  	{ required: true, message: '请填写职位', trigger: 'blur' }
          			],
					// contacts: [
          			//   	{ required: true, message: '请填写证明人', trigger: 'blur' }
          			// ]
				},

				//家庭成员相关数据
				user_relation_family_members_list:[],	
				user_relation_family_members_data:{
					name: "",
					relation: "",
					company_name: "",
					position: "",
					contact: "",
					null_data: false,
				},
				user_relation_family_members_loading:false,
				user_relation_family_members_visible:false,
				user_relation_family_members_rules:{
					name: [
          			  	{ required: true, message: '请填写姓名', trigger: 'blur' }
          			],
					relation: [
          			  	{ required: true, message: '请填写关系', trigger: 'blur' }
          			],
					company_name: [
          			  	{ required: true, message: '请填写公司名称', trigger: 'blur' }
          			],
					// position: [
          			//   	{ required: true, message: '请填写职位', trigger: 'blur' }
          			// ],
					contact: [
          			  	{ required: true, message: '请填写联系方式', trigger: 'blur' }
          			],
					// polit_face: [
          			//   	{ required: true, message: '请填写政治面貌', trigger: 'blur' }
          			// ]
				},

				//文件学历类型弹窗相关数据
				files_educational_model:'',
				filesEducationalFormVisible:false,

                dialogVisible:false, //身份证不匹配弹窗
			    cradInfo:{
			    	words_result:{
			    		'姓名':'',
			    		'性别':'',
			    		'民族':'',
			    		'公民身份号码':''
			    	}
			    },
				siblings_arr:[
            	    {
            	        arr:[],
            	        key:'province',
            	        nex_key:'city'
            	    },
            	    {
            	        arr:[],
            	        key:'city',
            	        nex_key:'district'
            	    },
            	    {
            	        arr:[],
            	        key:'district',
            	        nex_key:''
            	    }
            	],
				pickerOptions: {
        		  	disabledDate(time) {
        		  	  	return time.getTime() > Date.now();
        		  	}
        		},
				//审核状态提示
				approval_status_text:{
					2:'alert-danger',
					3:'alert-warning',
					5:'alert-success',
				},
				//电子学生卡弹窗
				student_id_card_visible:false,
				qrcode_value:'',
		
				school_extra: '',		// 院校配置
				admission_btn_visible: false,		// 录取通知书下载按钮显示状态
				mailing_apply: {},					// 录取通知书模板数据
            }
        }
        ,mounted:function(){
			let that = this
			this.$store.dispatch('get_const').then((res)=>{
				// 判断学籍数
				this.$store.dispatch('get_user_relation_count').then(res=>{
					if(this.$store.state.register_count != 0){
						this.$selfjs.getUserCallFn(this,function(res){
							that.school_extra = res.school.extra
						})
					}
				})
				//获取用户数据
				this.getMyUserRelation().then(res=>{
                    this.ruleForm = res
					if (this.ruleForm.register_status==1) {
						this.get_majors()
					}
					let pids = ''
                	for (let i = 0; i < this.siblings_arr.length; i++) {
                	    if (this.ruleForm.profile[this.siblings_arr[i].key]) {
							pids+=this.ruleForm.profile[this.siblings_arr[i].key]+','
						}else{
							this.ruleForm.profile[this.siblings_arr[i].key] = ''
							// break;
						}
                	}
                	this.get_siblings(pids) 
                    
					this.get_user_relation_files()
					this.get_user_list('user_relation_edus')
					this.get_user_list('user_relation_works')
					this.get_user_list('user_relation_family_members')
                })
			})   
			// 获取录取通知书模板
			this.my_mailing_apply()
        }
        ,methods:{
			my_mailing_apply(){
				// 获取我的邮寄申请数据
				this.$ajax.get(this.global.serverSrc + this.global.qianzui + "/enroll_advice_note/my_mailing_apply")
				.then(res=>{
					let resData = res.data
					if(resData.code == 0){
						if(resData.data){
							this.mailing_apply = resData.data
							let tpl = resData.data.tpl
							// 定义时间范围（精确到时分秒）
							const startTime = this.$moment(tpl.entrance_open_start_time, 'YYYY-MM-DD HH:mm:ss');
							const endTime = this.$moment(tpl.entrance_open_end_time, 'YYYY-MM-DD HH:mm:ss');
							const now = this.$moment(); // 当前时间

							// 判断当前时间是否在范围内
							this.admission_btn_visible = now.isBetween(startTime, endTime)
						}
					}
				})
			},
            // 基础信息表单数据初始化
            ruleFormInfon(){
                this.getMyUserRelation().then(res=>{
                    this.ruleForm = res
					let pids = ''
                	for (let i = 0; i < this.siblings_arr.length; i++) {
                	    if (this.ruleForm.profile[this.siblings_arr[i].key]) {
							pids+=this.ruleForm.profile[this.siblings_arr[i].key]+','
						}else{
							this.ruleForm.profile[this.siblings_arr[i].key] = ''
							// break;
						}
                	}
					this.get_siblings(pids)
					this.$forceUpdate();
					// console.log(this.ruleForm);
					
                    // this.get_majors()
					// this.get_user_relation_files()
                })
            },
			//获取同级地区列表
			get_siblings(pids){
				this.$ajax.get(this.global.serverSrc + this.global.qianzui +"/region/siblings",
					{
		    			params: {pids}
		    		}
				)
				.then((res)=>{
					let resData=res.data;
					if(resData.code==0){
						for (const key in resData.data) {
        	       		    let i = this.siblings_arr.findIndex(v=>{ return v.key==key })
							if (i!=-1) {
								this.siblings_arr[i].arr = resData.data[key]
							}
        	       		}
					}else{
						this.$message.error(resData.message)
					}
				})
        	},
        	//请求地区
        	get_children(key,pid){
        	    if (key) {
					this.$ajax.get(this.global.serverSrc + this.global.qianzui +"/region/children",
						{
		    				params: {pid}
		    			}
					)
					.then((res)=>{
						let resData=res.data;
						if(resData.code==0){
							let i = this.siblings_arr.findIndex(v=>{ return v.key==key })
        	           		this.siblings_arr[i].arr = resData.data
        	           		for (let l = i; l < this.siblings_arr.length; l++) {
        	           		    this.ruleForm.profile[this.siblings_arr[l].key] = ''
        	           		}
						}else{
							this.$message.error(resData.message)
						}
					})
        	    }
        	},
            //取消保存
            cancel_save(){
                this.ruleFormInfon()
                this.foundation_data_disabled=true
            },
			//点击保存
			foundation_save(){
				
				let add_data = {
					mobile:this.ruleForm.profile.mobile,
					polit_face:this.ruleForm.profile.polit_face,
					nation:this.ruleForm.profile.nation,
					household_register:this.ruleForm.profile.household_register,
					postcode:this.ruleForm.profile.postcode,
					address:this.ruleForm.profile.address,
					entrance_pic:this.ruleForm.profile.entrance_pic,
					id_frontend_thumb:this.ruleForm.profile.id_frontend_thumb,
					id_backend_thumb:this.ruleForm.profile.id_backend_thumb,
					// self_identification_file:this.ruleForm.profile.self_identification_file,
				}
				let add_data_text = {
					mobile:'请填写手机号码',
					polit_face:'请填写政治面貌',
					nation:'请填写民族',
					household_register:'请填写户籍',
					postcode:'请填写邮编',
					address:'请填写通讯地址',
					entrance_pic:'请上传证件照',
					id_frontend_thumb:'请上传身份证正面',
					id_backend_thumb:'请上传身份证反面',
					// self_identification_file:'请填写自我鉴定',
				}
				for (const key in add_data) {
					if (!add_data[key]) {
						this.$message.error(add_data_text[key]);
						return false
					}
				}
				this.$confirm('此操作将把修改的数据提交审核，是否继续?', '提示', {
        		  	confirmButtonText: '确定',
        		  	cancelButtonText: '取消',
        		  	type: 'warning'
        		}).then(() => {
        		  this.approval_add_reason = ''
				  this.approvalDialogFormVisible = true
        		}).catch(() => {
        		//   this.$message({
        		//     type: 'info',
        		//     message: '已取消删除'
        		//   });          
        		});
			},
			//基础信息修改
			approval_add(){
				let add_data = {
					relation_id:this.ruleForm.id,
					mobile:this.ruleForm.profile.mobile,
					polit_face:this.ruleForm.profile.polit_face,
					nation:this.ruleForm.profile.nation,
					household_register:this.ruleForm.profile.household_register,
					postcode:this.ruleForm.profile.postcode,
					email:this.ruleForm.profile.email,
					address:this.ruleForm.profile.address,
					is_overseas_chinese:this.ruleForm.profile.is_overseas_chinese,
					is_gangaotai:this.ruleForm.profile.is_gangaotai,
					is_disability:this.ruleForm.profile.is_disability,
					entrance_pic:this.ruleForm.profile.entrance_pic,
					id_frontend_thumb:this.ruleForm.profile.id_frontend_thumb,
					id_backend_thumb:this.ruleForm.profile.id_backend_thumb,
					reason:this.approval_add_reason,
					previous_name:this.ruleForm.profile.previous_name,
					marital_status:this.ruleForm.profile.marital_status,
					join_party_league:this.ruleForm.profile.join_party_league,
					award_or_punishment:this.ruleForm.profile.award_or_punishment,
					self_identification_file:this.ruleForm.profile.self_identification_file,
					province:this.ruleForm.profile.province,
					city:this.ruleForm.profile.city,
					district:this.ruleForm.profile.district,
				}
				if (this.approval_add_reason=='') {
					this.$message.error('请填写申请理由！');
					return false
				}
				const loading = this.$loading({
        		  	lock: true,
        		  	text: 'Loading',
        		  	spinner: 'el-icon-loading',
        		  	background: 'rgba(0, 0, 0, 0.7)'
        		});
            	this.$ajax.post(
		    		this.global.serverSrc + this.global.qianzui + '/approval/add',
            	    this.$qs.stringify(add_data)
		    	).then((res)=>{
            	    loading.close()
		    		let resData = res.data
		    		if(resData.code==0){
                        this.ruleFormInfon()
            	        this.$message.success('申请成功！');
						this.approvalDialogFormVisible = false
						this.foundation_data_disabled = true
		    		}
		    	}).catch(()=> {
            	    loading.close()
					this.$alert('申请异常', '信息提示', {
						confirmButtonText: '确定',
					});
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
			},
			//获取可异动的专业
			get_majors(){
				this.$ajax.get(
		    		this.global.serverSrc + this.global.qianzui + '/approval/majors',
					{
		        		params: {relation_id:this.ruleForm.id}
		        	}
		    	)
		    	.then((res)=>{
            	    let resData = res.data
		    		if(resData.code==0){        
						this.approval_majors_arr = resData.data            
            	        // this.select_number = resData.data.max_select_course_count
            	    } 
		    	})
			},
			//点击申请异动
			apply_for_unusual_change(){
				this.approval_majors_reason = ''
				this.approval_majors_grade_id = (this.ruleForm.grade?this.ruleForm.grade.grade_id:'')
				this.attachments = []
				this.majorsDialogFormVisible = true
			},
			//学籍异动审核
			add_relation_change(){
				let add_data = {
					relation_id:this.ruleForm.id,
					grade_id:this.approval_majors_grade_id,
					reason:this.approval_majors_reason,
					attachments:this.attachments
				}
				if (this.approval_majors_grade_id=='') {
					this.$message.error('请选择需要修改的班级！');
					return false
				}
				if (this.approval_majors_grade_id==(this.ruleForm.grade?this.ruleForm.grade.grade_id:'')) {
					this.$message.error('你已经在此班级，无需再申请！');
					return false
				}
				if (this.approval_majors_reason=='') {
					this.$message.error('请填写申请理由！');
					return false
				}
				const loading = this.$loading({
        		  	lock: true,
        		  	text: 'Loading',
        		  	spinner: 'el-icon-loading',
        		  	background: 'rgba(0, 0, 0, 0.7)'
        		});
            	this.$ajax.post(
		    		this.global.serverSrc + this.global.qianzui + '/approval/add_relation_change',
            	    this.$qs.stringify(add_data)
		    	).then((res)=>{
            	    loading.close()
		    		let resData = res.data
		    		if(resData.code==0){
            	        this.$message.success('申请成功！');
						this.majorsDialogFormVisible = false
		    		}
		    	}).catch(()=> {
            	    loading.close()
					this.$alert('申请异常', '信息提示', {
						confirmButtonText: '确定',
					});
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
			},
			selectImage1(file_txt){
        	    this.$refs[file_txt].click();
        	},
        	change1(event,file_txt) {
				// console.log(event);
				
        	    let file = event.target.files[0];
        	    this.imgChange(file,file_txt)
				this.$refs[file_txt].value = '';
        	},
        	// 上传阿里云
        	async imgChange (file,file_txt) {
        	    // console.log(file);
        	    let that = this
        	    if(file==undefined){return false}
        	    if(file.size > 5242880){
					this.$alert('文件大小不能超过5MB', '信息提示', {
						confirmButtonText: '确定'
					})
        	        return false
				}
				if(file.type != "image/jpg" && file.type != "image/jpeg" && file.type != "image/png" && file.type != "application/pdf"){
		    		this.$alert('只能上传jpg/jpeg/png/pdf文件', '信息提示', {
		    			confirmButtonText: '确定'
		    		})
		    		return false
		    	}
        	    const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
        	    //验证通过，上传文件
        	    let flname = this.$selfjs.createOssFileName()
				let upload_path = `xuexi.qsxueli.com/uploadFile/approval_audit/${flname}.${file.name.substring(file.name.lastIndexOf(".")+1)}`;
				this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/approval_audit'}))
			    .then(res=>{
					let resData = res.data
					if(resData.code==0){
						let oss_data = new FormData()
						oss_data.append("key",upload_path);
 						oss_data.append("policy", resData.data.policy);
 						oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 						oss_data.append("success_action_status", '200');
 						oss_data.append("signature", resData.data.signature);
 						oss_data.append("file", file, file.name);
						this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
							loading.close()
							// console.log(res);
							if (res.ok) {
								if (file_txt=='file') {
									this.attachments.push({
        	                    	    title: file.name.substring(0, file.name.lastIndexOf(".")),
	    	    	            	    url: upload_path
        	                    	})	
								}else if (file_txt=='front_file'||file_txt=='evidence_file') {
									let type_i = file_txt=='front_file' ? 0 : 1
									let title = file_txt=='front_file' ? this.education.find(v=>{return this.files_educational_model == v.id}).value : file.name.substring(0, file.name.lastIndexOf("."))
									this.user_relation_files_data.data[type_i].attachments.push({
        	                    	    title,
	    	    	            	    url: upload_path
        	                    	})	
									this.files_educational_model = ''
									this.filesEducationalFormVisible = false
									this.$forceUpdate();
								}
        	                    // that.imgsrc1 = that.global.oss_link+upload_path
        	                    this.$message.success('上传成功')
        	                    // console.log(that.attachment);
							}else{
								this.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
									confirmButtonText: '确定',
								});
							}
						})
					}else{
        	            loading.close()
						that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
							confirmButtonText: '确定',
						});
						this.$message.error(resData.message)
					}
			    }).catch(_ => {
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
					loading.close()
				});
        	},
			//删除附件
			attachment_delete(i,file_txt){
				if (file_txt=='file') {
					this.$selfjs.delOssFile(this, [this.global.oss_link+this.attachments[i].url])
					this.attachments.splice(i, 1)
				}else if(file_txt=='front_file'||file_txt=='evidence_file'){
					let type_i = file_txt=='front_file'?0:1
					this.$selfjs.delOssFile(this, [this.global.oss_link+this.user_relation_files_data.data[type_i].attachments[i].url])
					this.user_relation_files_data.data[type_i].attachments.splice(i, 1)
					this.$forceUpdate();
				}

			},
			//点击上传前置学历文件
			user_relation_files_open(){
				this.user_relation_files_data={
					// attachments:[],
					data:[
						{
                		    type: 1,
                		    attachments: [],
                		},
						{
                		    type: 2,
                		    attachments: [],
                		}
					],
					type:1,
					remark:''
				}
				this.userRelationFilesFormVisible = true
			},
			//前置学历文件学历类型确认
			files_educational(){
				if (!this.files_educational_model) {
					this.$message.error('请选择文件学历类型')
					return false
				}
				this.selectImage1('front_file')
			},
			//获取前置学历文件列表
			get_user_relation_files(){
				this.$ajax.get(this.global.serverSrc + this.global.qianzui +"/user_relation_files",
					{
		    			params: {limit:999,user_relation_id:this.ruleForm.id}
		    		}
				)
				.then((res)=>{
					let resData=res.data;
					this.files_table_loading = false
					if(resData.code==0){
						this.user_relation_files_list = resData.data.data
						
					}else{
						this.$message.error(resData.message)
						// console.log(resData.message);
					}
				})
			},
			//前置学历文件保存
			post_user_relation_files(){
				let add_data = this.user_relation_files_data
				add_data.relation_id = this.ruleForm.id
				if (!add_data.data[0].attachments.length&&!add_data.data[1].attachments.length) {
					this.$message.error('请选择需要上传的文件！');
					return false
				}

				const loading = this.$loading({
        		  	lock: true,
        		  	text: 'Loading',
        		  	spinner: 'el-icon-loading',
        		  	background: 'rgba(0, 0, 0, 0.7)'
        		});
        		this.$ajax.post(
					this.global.serverSrc + this.global.qianzui + '/user_relation_files',
        		    this.$qs.stringify(add_data)
				).then((res)=>{
        		    loading.close()
					let resData = res.data
					if(resData.code==0){
						this.get_user_relation_files()
        		        this.$message.success('保存成功！');
						this.userRelationFilesFormVisible = false
					}
				}).catch(()=> {
        		    loading.close()
					this.$alert('保存异常', '信息提示', {
						confirmButtonText: '确定',
					});
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
			},
			//查看文件
			view_file(url){
				window.open(this.global.oss_link+url)
			},
			//获取常量名称
			get_const_txt(arr,id){
				return id ? arr.find(v=>{return v.id == id}).value : '无'
			},
			//删除前置学历文件
			delete_file(id,url){
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        		  	confirmButtonText: '确定',
        		  	cancelButtonText: '取消',
        		  	type: 'warning'
        		}).then(() => {
					const loading = this.$loading({
        			  	lock: true,
        			  	text: 'Loading',
        			  	spinner: 'el-icon-loading',
        			  	background: 'rgba(0, 0, 0, 0.7)'
        			});
        			this.$ajax.delete(
						this.global.serverSrc + this.global.qianzui + '/user_relation_files/'+id,
        			    {params:{id}}
					).then((res)=>{
        			    loading.close()
						let resData = res.data
						if(resData.code==0){
							this.$selfjs.delOssFile(this, [this.global.oss_link+url])
							this.get_user_relation_files()
        			        this.$message.success('删除成功！');
						}
					}).catch(()=> {
        			    loading.close()
						this.$alert('删除异常', '信息提示', {
							confirmButtonText: '确定',
						});
						// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
					});
        		}).catch(() => {        
        		});
			},
            upimg(file,sdtype){
		    	let Base64 = ''
		    	if (file.length>1) {
		    		this.$message.warning('只能传一张')
		    		return false
		    	}
				// && file[0].type != "image/png"
		    	if(file[0].type != "image/jpg" && file[0].type != "image/jpeg" ){
		    		this.$alert('只能上传jpg/jpeg文件', '信息提示', {
		    			confirmButtonText: '确定'
		    		})
		    		return false
		    	}
		    	if(file.size > 5242880){
		    		this.$alert('图片大小不能超过5m', '信息提示', {
		    			confirmButtonText: '确定'
		    		})
		    		return false
		    	}
				if (sdtype=='entrance_pic') {
					this.resizeImage(file[0],390,567).then(result => {
						this.upLoad('',sdtype,result)
					})
				}else{
					this.upLoad('',sdtype,file[0])
				}
		    	// this.getBase64(file[0]).then(result => {
		    	// 	// Base64 = result.replace(/^data:image\/\w+;base64,/, "")
		    	// 	// this.id_card_identification(Base64,sdtype,file[0])
                //     this.upLoad(result,sdtype,file[0])
		    	// })
		    },
			//文件压缩
			resizeImage(file, targetWidth, targetHeight) {
    		  	return new Promise((resolve) => {
    		  	  	const img = new Image();
    		  	  	img.src = URL.createObjectURL(file);
					
    		  	  	img.onload = () => {
    		  	  	  	const canvas = document.createElement('canvas');
    		  	  	  	const ctx = canvas.getContext('2d');

    		  	  	  	// 设置目标尺寸
    		  	  	  	canvas.width = targetWidth;
    		  	  	  	canvas.height = targetHeight;

    		  	  	  	// 绘制并缩放图片
    		  	  	  	ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

    		  	  	  	// 转换为 Blob 文件
    		  	  	  	canvas.toBlob((blob) => {
    		  	  	  	  resolve(new File([blob], file.name, { type: file.type }));
    		  	  	  	}, 'image/jpeg', 0.8); // 质量 0-1
    		  	  	};
    		  	});
    		},
            handle_exceed(file){ //文件超出回调，用于身份证上传
		    	this.upimg(file,'id_frontend_thumb')
		    },
		    handle_exceed_fan(file){
		    	this.upimg(file,'id_backend_thumb')
		    },
			handle_exceed_entrance_pic(file){ 
		    	this.upimg(file,'entrance_pic')
		    },
            // 转base64
    	    getBase64(file,imgUrl) {
		    	if (file) {
		    		// 获取到文件对象
                	var file = file;
                	// 获取FileReader实例
                	var reader = new FileReader();
                	// 将文件加载进入
                	reader.readAsDataURL(file);
                
		    		const promise = new Promise((resolve, reject) => {
		    		  	// 异步操作
		    			reader.onload = function (e) { 
                		    // 转换完成输出该文件base64编码
		    				resolve(this.result);
                		}
		    		});
		    		return promise
		    	}else{
		    		let image = new Image();
      	    		// 解决跨域问题
      	    		image.setAttribute("crossOrigin", "anonymous");
      	    		let imageUrl = imgUrl;
      	    		image.src = imageUrl;
      	    		// image.onload为异步加载
      	    		// eslint-disable-next-line no-undef
		    		const promise = new Promise((resolve, reject) => {
		    		  	// 异步操作
		    			image.onload = function() {
      	    			  	var canvas = document.createElement("canvas");
      	    			  	canvas.width = image.width;
      	    			  	canvas.height = image.height;
      	    			  	var context = canvas.getContext("2d");
      	    			  	// eslint-disable-next-line no-undef
      	    			  	context.drawImage(image, 0, 0, image.width, image.height);
      	    			  	var quality = 1;
      	    			  	// 这里的dataurl就是base64类型
      	    			  	// 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
      	    			  	let dataurl = canvas.toDataURL("image/jpeg", quality);
      	    			  	// sBase64 = dataurl
		    				resolve(dataurl);
      	    			};
		    		});
		    		return promise
		    	}
            
		    },
            //身份证校验
		    id_card_identification(base64,sdtype,file){
		    	const loading = this.$loading({
		    		lock: true,
		    		text: 'Loading',
		    		spinner: 'el-icon-loading',
		    		background: 'rgba(0, 0, 0, 0.7)'
		    	});
		    	let serverSrc=this.global.serverSrc
		    	,qianzui=this.global.qianzui;
		    	let token=this.$cookies.get("token")
		    	let that = this
		    	//用于身份证裁剪及提取信息进行比对
                this.$ajax.post(serverSrc + qianzui + "/aliyun/id_card_identification",this.$qs.stringify({
		    		image_base64:base64,
		    		id_card_side:sdtype=='id_frontend_thumb'?'back':'front'
		    	}))
		        .then(res=>{
		    		let resData=res.data.data;
		    		if (resData.risk_type=='normal') {
		    			if (resData.image_status=='normal') {
		    				let base64_card_image = resData.card_image
		    				if (sdtype=='id_backend_thumb') {
		    					that.cradInfo = resData
		    					// that.dialogVisible = true
		    					if (that.ruleForm.profile.idcard+''===resData.words_result['公民身份号码'].words&&that.ruleForm.profile.nick_name===resData.words_result['姓名'].words) {
		    						that.upLoad('data:image/jpeg;base64,'+base64_card_image,sdtype,file)
		    					}else{
		    						that.dialogVisible = true
		    					}
		    				}else{
		    					that.upLoad('data:image/jpeg;base64,'+base64_card_image, sdtype,file)
		    				}
		    			}else{
		    				that.$message.error(that.image_status_text[resData.image_status])
		    			}
		    		}else{
		    			that.$message.error('请上传正确身份证！')
		    		}
		    		loading.close()
		        }).catch(_ => {
		    		loading.close()
		    		this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
		    	});
		    },
            //上传
		    upLoad(base64,sdtype,file){
		    	let that = this
		    	// let file = that.base64toFile(base64)
		    	const loading = this.$loading({
		    		lock: true,
		    		text: 'Loading',
		    		spinner: 'el-icon-loading',
		    		background: 'rgba(0, 0, 0, 0.7)'
		    	});
		    	let flname = this.$selfjs.createOssFileName()
		    	// if (sdtype==15||sdtype==16) {
		    	// 	flname = sdtype==15?'yangbenzheng':'yangbenfan'
		    	// }
		    	//验证通过，上传图片
		    	let upload_path = `xuexi.qsxueli.com/uploadFile/student/documents/${that.ruleForm.id}/${flname}.${file.name.substring(file.name.lastIndexOf(".")+1)}`;
		    	this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/student/documents/'+that.ruleForm.id}))
		        .then(res=>{
		    		let resData = res.data
		    		if(resData.code==0){
		    			let oss_data = new FormData()
		    			oss_data.append("key",upload_path);
 		    			oss_data.append("policy", resData.data.policy);
 		    			oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 		    			oss_data.append("success_action_status", '200');
 		    			oss_data.append("signature", resData.data.signature);
 		    			oss_data.append("file", file);
                    
		    			this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
		    				// console.log(res);
		    				if (res.ok) {
		    					// console.log(sdtype);
								that.$set(this.ruleForm.profile, sdtype, upload_path);
		    					// that.ruleForm[sdtype] = upload_path
								// console.log(that.ruleForm);
								

		    				}else{
		    					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
		    						confirmButtonText: '确定',
		    					});
		    					fileList.splice(fileList.length-1, 1)
		    				}
		    			})
		    		}else{
		    			that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
		    				confirmButtonText: '确定',
		    			});
		    		}
		    		loading.close()
		        }).catch(_ => {
		    		that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
		    			confirmButtonText: '确定',
		    		});
		    		// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
		    		loading.close()
		    	});
		    },
			//获取列表
			get_user_list(url){
				this[url+'_loading'] = true
				this.$ajax.get(this.global.serverSrc + this.global.qianzui +"/"+url,
					{
		    			params: {user_relation_id:this.ruleForm.id}
		    		}
				)
				.then((res)=>{
					let resData=res.data;
					this[url+'_loading'] = false
					if(resData.code==0){
						this[url+'_list'] = resData.data.data
						
					}else{
						this.$message.error(resData.message)
						// console.log(resData.message);
					}
				})
			},
			//新增/编辑
			edit_data(url,item){
				this[url+'_visible'] = true
				if (item) {
					this.visible_loading = true
					let attach_url = this.global.serverSrc + this.global.qianzui + "/"+url+"/" + item.id
					this.$ajax.get(attach_url)
					.then((res)=>{
						let resData=res.data
							// console.log(resData);
							try {
								this.$refs[url+'_ref'].resetFields();
							} catch (error) {
							}
						if(resData.code==0){
							this[url+'_data'] = resData.data
							// if(this[url+'_data'].start_date){
							// 	this.$set(this[url+'_data'], 'datetime', [this[url+'_data'].start_date, this[url+'_data'].end_date]);
							// }
						}else{
							this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
						}
						this.visible_loading = false
					})
					.catch(_ => {
		    			this.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
		    				confirmButtonText: '确定',
		    			});
		    			this.visible_loading = false
		    		});
				}else{
					for (const key in this[url+'_data']) {
						this[url+'_data'][key] = ''
					}
					try {
						this.$refs[url+'_ref'].resetFields();
					} catch (error) {
					}
				}
			},
			//删除
			delete_data(url,item){
				this.$confirm('确定删除?', '提示', {
        		  	confirmButtonText: '确定',
        		  	cancelButtonText: '取消',
        		  	type: 'warning'
        		}).then(() => {
					const loading = this.$loading({
        			  	lock: true,
        			  	text: 'Loading',
        			  	spinner: 'el-icon-loading',
        			  	background: 'rgba(0, 0, 0, 0.7)'
        			});
        			this.$ajax.delete(
						this.global.serverSrc + this.global.qianzui + '/'+url+'/'+item.id,
					).then((res)=>{
        			    loading.close()
						let resData = res.data
						if(resData.code==0){
							this.get_user_list(url)
							this.ruleFormInfon()
        			        this.$message.success('删除成功！');
						}
					}).catch(()=> {
        			    loading.close()
						this.$alert('删除异常', '信息提示', {
							confirmButtonText: '确定',
						});
						// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
					});
        		}).catch(() => {        
        		});
			},
			//保存
			save_data(url){
				// console.log(this[url+'_data']);
				// console.log(this[url+'_data'].id?'put':'post');
				// return false
				this.$refs[url+'_ref'].validate((valid) => {
        		  	if (valid || this[url+'_data'].null_data) {
						const loading = this.$loading({
        				  	lock: true,
        				  	text: 'Loading',
        				  	spinner: 'el-icon-loading',
        				  	background: 'rgba(0, 0, 0, 0.7)'
        				});
						this[url+'_data'].user_relation_id = this.ruleForm.id
						// if(this[url+'_data'].datetime){
						// 	this[url+'_data'].start_date = this[url+'_data'].datetime[0],
						// 	this[url+'_data'].end_date = this[url+'_data'].datetime[1]
						// }
            			this.$ajax[this[url+'_data'].id?'putJson':'post'](
		    				this.global.serverSrc + this.global.qianzui + '/'+url+ (this[url+'_data'].id?'/'+this[url+'_data'].id:'') ,
            			    this.$qs.stringify(this[url+'_data'])
		    			).then((res)=>{
            			    loading.close()
		    				let resData = res.data
		    				if(resData.code==0){
                		        this.get_user_list(url)
            			        this.$message.success('保存成功！');
								this[url+'_visible'] = false
		    				}
							// 初始化状态
							this[url+'_data'].null_data = false
		    			}).catch(()=> {
            			    loading.close()
							this.$alert('保存异常', '信息提示', {
								confirmButtonText: '确定',
							});
							// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
						});
        		  	} else {
        		  	  	// console.log('error submit!!');
        		  	  	return false;
        		  	}
        		});
			},
			//选择事件
			user_relation_edus_education_level(e){
				if (e&&(e==1||e==2||e==3)) {
					this.user_relation_edus_data.major = '学生'
				}
			},
			//电子学生证
			student_id_card(){
				this.student_id_card_visible = true
			},
			student_id_card_opened(){
				// console.log($("#qr_code"));
				$("#qr_code")[0].innerHTML = '' // 清空之前生成的二维码内容
				new QRCode('qr_code',{
            	    width: 86, // 设置宽度，单位像素
            	    height: 86, // 设置高度，单位像素
            	    text: `https://xuexi.qsxueli.com/wap/#/pages_userCenter/student_id_information?user_relation_id=${this.ruleForm.id}`// 设置二维码内容或跳转地址(完整链接)
            	})
			},
            // swmubanFn:function(res){
            //     this.$emit("swmuban",res);		//修改app.vue 的 muban_bol 值
            // }
			admission_visible(){
				this.$refs.admission_ref.visible = true
			}
        }
		,computed:{
			//页面功能
			disable_edit(){
				return this.ruleForm.disable_edit == 2
			},
			education(){
				let consts = this.$store.state.const
				if(consts){
					return this.$store.state.const.common.education
				}else{
					return []
				}
			},
			marital_status(){
				let consts = this.$store.state.const
				if(consts){
					return this.$store.state.const.common.marital_status
				}else{
					return []
				}
			}
		}
        ,watch: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- scoped单页面有效属性 -->

<style>
/* body #app{min-height:100%;} */
</style>
<style>
</style>
    


// WEBPACK FOOTER //
// src/components/userCenter/user_component.vue